import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["categories", "categoryContainer"];

  connect() {
    this.initializeSortables();
  }

  initializeSortables() {
    // Make categories sortable (reorder entire categories)
    if (this.hasCategoriesTarget) {
      $(this.categoriesTarget).sortable({
        handle: ".category-drag-handle",
        axis: "y",
        update: (event, ui) => {
          this.saveCategoryOrder();
        },
      });
    }

    // Make items within each category sortable
    this.categoryContainerTargets.forEach((container) => {
      const categoryId = container.dataset.categoryId;

      $(container).sortable({
        handle: ".item-drag-handle",
        connectWith: ".sortable-items", // Allow dragging between categories
        placeholder: "sortable-placeholder",
        update: (event, ui) => {
          // Only trigger if the item ended up in THIS container
          if (ui.item.parent()[0] === container) {
            this.saveItemOrder(container, categoryId);
          }
        },
        receive: (event, ui) => {
          // Item was moved FROM another category TO this one
          this.saveItemOrder(container, categoryId);
        },
      });
    });
  }

  async saveCategoryOrder() {
    const categoryIds = $(this.categoriesTarget)
      .children(".category-section")
      .map(function () {
        return $(this).data("category-id");
      })
      .get();

    try {
      const response = await fetch("/checklist_categories/sort", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('[name="csrf-token"]')
            .content,
        },
        body: JSON.stringify({ category_ids: categoryIds }),
      });

      if (!response.ok) {
        throw new Error("Failed to save category order");
      }

      this.showSuccess("Category order updated");
    } catch (error) {
      console.error("Error saving category order:", error);
      this.showError("Failed to save category order");
    }
  }

  async saveItemOrder(container, categoryId) {
    const $container = $(container);
    const itemIds = $container
      .children(".checklist-item-sortable")
      .map(function () {
        return $(this).data("item-id");
      })
      .get();

    // Get the first item's ID to know what was moved
    const movedItemId = itemIds[0] || $container.find(".checklist-item-sortable").first().data("item-id");

    if (!movedItemId) return;

    try {
      const response = await fetch(`/skills/${this.skillId}/sort_items`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('[name="csrf-token"]')
            .content,
        },
        body: JSON.stringify({
          item_id: movedItemId,
          category_id: categoryId || null,
          item_ids: itemIds,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to save item order");
      }

      this.showSuccess("Checklist order updated");
    } catch (error) {
      console.error("Error saving item order:", error);
      this.showError("Failed to save item order");
    }
  }

  get skillId() {
    return this.element.dataset.skillId;
  }

  showSuccess(message) {
    const flash = document.createElement("div");
    flash.className = "alert alert-success alert-dismissible";
    flash.style.cssText =
      "position: fixed; top: 70px; right: 20px; z-index: 9999; min-width: 300px;";
    flash.innerHTML = `
      ${message}
      <button type="button" class="close" data-dismiss="alert">&times;</button>
    `;
    document.body.appendChild(flash);
    setTimeout(() => flash.remove(), 3000);
  }

  showError(message) {
    const flash = document.createElement("div");
    flash.className = "alert alert-danger alert-dismissible";
    flash.style.cssText =
      "position: fixed; top: 70px; right: 20px; z-index: 9999; min-width: 300px;";
    flash.innerHTML = `
      ${message}
      <button type="button" class="close" data-dismiss="alert">&times;</button>
    `;
    document.body.appendChild(flash);
    setTimeout(() => flash.remove(), 5000);
  }
}


